import { HttpErrorResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";

import { CanalesAsociarUsuarioService } from "@Canales/Shared/Services/canales-asociar-usuario.service";
import { IUsuarioSeguros } from "@Canales/Shared/Types/Interfaces/asociar-usuario.interface";

@Component({
  selector: "app-asociar-usuario",
  templateUrl: "./asociar-usuario.component.html",
  styleUrls: ["./asociar-usuario.component.scss"],
})
export class AsociarUsuarioComponent {
  public usuarioForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private readonly canalesAsociarUsuarioService: CanalesAsociarUsuarioService,
    private readonly toastr: ToastrService
  ) {
    this.usuarioForm = this.fb.group({
      codUsr: ["", [Validators.required]],
      identificacion: ["", [Validators.required, Validators.email]],
      tipoIdent: ["E"],
      codInter: [""],
      tipoInfo: ["PER"],
    });
  }

  public onSubmit(): void {
    if (this.usuarioForm.invalid) {
      this.usuarioForm.markAllAsTouched();
      return;
    }
    const payload = {
      codUsr: this.usuarioForm.get("identificacion")?.value ?? "",
      identificacion: this.usuarioForm.get("codUsr")?.value ?? "",
      tipoIdent: "E",
      codInter: this.usuarioForm.get("codInter")?.value ?? "",
      tipoInfo: this.usuarioForm.get("tipoInfo")?.value ?? "PER",
    } as IUsuarioSeguros;

    this.canalesAsociarUsuarioService.asociarUsuario(payload).subscribe({
      next: () => {
        this.toastr.success("Usuario asociado exitosamente", "Aviso", {
          timeOut: 3000,
        });
        this.usuarioForm.reset();
      },
      error: (error: HttpErrorResponse) => {
        console.warn(error.message);
        this.toastr.error("Error al enviar los datos", "Aviso", {
          timeOut: 3000,
        });
      },
    });
  }
}
